import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './ComboModifierField.module.scss';

const ComboModifierField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			{dishForFullInfo?.comboModifier?.name ? (
				<>
					<Text translationKey={dishForFullInfo.comboModifier.name || ''} size="s" withTooltip={true} />
					{dishForFullInfo.comboModifier.externalId ? (
						<ChunkOfTextWithCopying
							text={dishForFullInfo.comboModifier.externalId}
							className={style.externalId}
						/>
					) : (
						<Text className={style.externalId} translationKey="-" />
					)}
				</>
			) : (
				'-'
			)}
		</div>
	);
};

export default ComboModifierField;
